export function buildLinkedInShareUrl(text: string): string {
  const params = new URLSearchParams();
  params.set('mini', 'true');
  params.set('title', text.slice(0, 200));
  return `https://www.linkedin.com/shareArticle?${params.toString()}`;
}

export function buildXShareUrl(text: string, hashtags?: string[]): string {
  const params = new URLSearchParams();
  const fullText = hashtags?.length
    ? `${text}\n\n${hashtags.map((h) => `#${h}`).join(' ')}`
    : text;
  params.set('text', fullText.slice(0, 280));
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

export function formatHashtags(hashtags?: string[]): string {
  if (!hashtags?.length) return '';
  return hashtags.map((h) => `#${h.replace(/^#/, '')}`).join(' ');
}
